//TODO vervangen door EnumConstantsMixin zoals in NR?
export enum StatusEnum {
  NULL = '',
  INGEDIEND = 'INGEDIEND',
  IN_BEWERKING = 'IN_BEWERKING',
  GEVALIDEERD_EN_INGEDIEND = 'GEVALIDEERD_EN_INGEDIEND',
  TE_VALIDEREN = 'TE_VALIDEREN',
  GEWEIGERD = 'GEWEIGERD',
}
